import Vue from 'vue';
import Chartkick from 'vue-chartkick';
import Chart from 'chart.js';

import Toast from 'vue-toastification';

import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';

import 'vue-toastification/dist/index.css';

import App from './App.vue';
import router from './router';

Vue.config.productionTip = false;
Vue.use(Chartkick.use(Chart));

Vue.use(Toast, { hideProgressBar: true });
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);

new Vue({
  router,
  render: (h) => h(App),
}).$mount('#app');
